import LinkToDocusaurus from '../LinkToDocusaurus'
import { Paragraph } from '@eggplant/pattern-library'
import { models } from '../../docs-routes'

const description = 'Select the space you want to move or duplicate assets from the Space drop-down list below.'

const SpaceCreatedImportAssetsInfo = () =>
  <Paragraph>
    <strong>
      {description}
      <br />
      <LinkToDocusaurus path={models}>Learn more in the DAI documentation</LinkToDocusaurus>
    </strong>
  </Paragraph>

export default SpaceCreatedImportAssetsInfo
